import $ from 'jquery';

const $ajaxAddToCartButton = $('.js-ajax-add-to-cart');
const $miniCart = $('.js-mini-cart');
const $headerCart = $('.js-header-cart');
const $cartContentsCount = $('.js-cart-contents-count');
const $quantityField = $('input[name="quantity"]');
const $siteHeader = $('.js-site-header');
const $siteHeaderWrapper = $('.js-site-header-wrapper');
const $body = $('body');
const buttonResetTiming = 5000;
const miniCartResetTiming = 7000;
let miniCartHidingTimer;

let processing = false;

$(function() {

    $miniCart.on('click', function(e) {
        e.stopPropagation();
    });

    $body.on('added_to_cart', function(e, fragments, cart_hash, $button) {

        // get the mini cart HTML from the response
        const $miniCartContents = $(fragments['div.widget_shopping_cart_content']);

        // get top position
        const cartTop = $siteHeader.get(0).getBoundingClientRect().top + $siteHeader.outerHeight();
        const cartRight = (window.innerWidth - $siteHeaderWrapper.width()) / 2 - 8;
        $miniCartContents.find('.js-mini-cart-holder').css({
            'top': cartTop,
            'right': cartRight,
        });

        // update the mini cart HTML
        $miniCart.html($miniCartContents);

        // update the cart items count
        $cartContentsCount.text(fragments['cart-contents-count']);

        // tell the UI we have items in the cart
        $headerCart.addClass('has-items');

        $(document).one('click', hideMiniCart);
        miniCartHidingTimer = setTimeout(hideMiniCart, miniCartResetTiming);
    });

    $miniCart.on('mouseenter', function() {
        clearTimeout(miniCartHidingTimer);
    });

    $miniCart.on('mouseleave', function() {
        miniCartHidingTimer = setTimeout(hideMiniCart, miniCartResetTiming);
    });

    const hideMiniCart = e => {
        if (e) {
            e.preventDefault();
        }

        const $miniCartContents = $miniCart.children();

        $(document).off('click', hideMiniCart);

        $miniCartContents.fadeOut(200, function() {
            $miniCartContents.remove();
        });
    }

    $ajaxAddToCartButton.on('click', function(e) {

        e.preventDefault();

        if (processing) return;

        processing = true;

        const $button = $(this);
        const product_qty = $quantityField.val() || 1;
        const product_id = $button.data('product_id') || id;

        var data = {
            action: 'yt_woocommerce_ajax_add_to_cart',
            product_id: product_id,
            quantity: product_qty,
        };

        $.ajax({
            type: 'POST',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            beforeSend: function(response) {
                $ajaxAddToCartButton.addClass('is-loading');
            },
        }).done((response) => {

            // handle error
            if (response.error) {
                alert('Whoops! An error occurred - please try again');
                processing = false;
                return;
            }

            // update button
            $ajaxAddToCartButton.addClass('is-complete');

            // trigger event
            $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $button]);

            // Update the global cart contents count
            const cartContentsCount = response.fragments['cart-contents-count'];
            $cartContentsCount.text(cartContentsCount);

            // Toggle the visibility of the cart count span
            if (cartContentsCount > 0) {
                $('.site-header__basket-icon').addClass('site-header__basket-icon--active');
                $('.site-header__basket-count').removeClass('hidden');  // Show the cart count span
            } else {
                $('.site-header__basket-icon').removeClass('site-header__basket-icon--active');
                $('.site-header__basket-count').addClass('hidden');  // Hide the cart count span if no items
            }
    
            // revert button state
            setTimeout(() => {
                $ajaxAddToCartButton.removeClass('is-complete');
                processing = false;
            }, buttonResetTiming);

        }).fail((error) => {
            if (response.error) {
                alert('Whoops! An error occurred - please try again');
                processing = false;
                return;
            }
        }).always(() => {
            $ajaxAddToCartButton.removeClass('is-loading')
        });

    });

    $('.js-paypal-cta').on('click', function(){
        var moreCTA = $(this);
        var moreBlock = $('.js-paypal-info');
        if(!moreCTA.hasClass('open')) {
            moreCTA.text('See less');
            moreCTA.addClass('open');
            moreBlock.slideDown(500);
        } else {
            moreCTA.text('Learn more');
            moreCTA.removeClass('open');
            moreBlock.slideUp(500);
        }
    });
});
